import {Tabs} from '@/components';
import AppRatesList from '@/screens/Rates/App';
import PromoTiersList from '@/screens/Rates/Promo';
import RatesUpload from '@/screens/Rates/Upload';
import type {TabItem} from '@/types';

const BusinessRates = () => {
  const ratesTabs: TabItem[] = [
    {
      id: 'app-rates',
      title: 'Business App Rates',
      dataCy: 'merchant-rates-tab-app-rates',
      content: <AppRatesList target="BUSINESS" dataCy="merchant-rates-list" />,
    },
    {
      id: 'upload',
      title: 'Upload Business Rates',
      dataCy: 'merchant-rates-tab-upload',
      content: <RatesUpload target="BUSINESS" dataCy="merchant-rates-upload" />,
    },

    {
      id: 'promo-rates',
      title: 'Business Rate Promo',
      dataCy: 'merchant-rates-tab-promo-rates',
      content: (
        <PromoTiersList target="BUSINESS" dataCy="merchant-rates-promo" />
      ),
    },
  ];
  return <Tabs tabs={ratesTabs} queryKey="tab" />;
};
export default BusinessRates;
